import "./src/styles/global.css"
import "./static/fa-5.15/css/all.min.css"